import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndicadorService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getIndicador(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaIndicadorAccionEspecificas', { headers: this.header(this.token) });
  }

  getIndicadorById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaIndicadorAccionEspecifica/' + id, { headers: this.header(this.token) });
  }

  getPoaIndicadoresAccionEspecifica(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaIndicadoresAccionEspecifica/' + id, { headers: this.header(this.token) });
  }  

  getIndicadoresAccionEspecifica(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadoresAccionEspecifica/' + id, { headers: this.header(this.token) });
  } 

  postIndicador(indicador: any): Observable<any> {
    return this.http.post(this.baseUrl + 'poaIndicadorAccionEspecifica', indicador, { headers: this.header(this.token) });
  }

  putIndicador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaIndicadorAccionEspecifica', bodyString, { headers: this.header(this.token) });
  }

  deleteIndicador(id: number): Observable<any> {    
    return this.http.delete(this.baseUrl + 'poaIndicadorAccionEspecifica/' + id, { headers: this.header(this.token) });
    
  }

  postIndicadorRiesgos(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaIndicadorAeRiesgos', bodyString, { headers: this.header(this.token) });
  }
}
